import { render, staticRenderFns } from "./ProjectViewProjectPlanCard.vue?vue&type=template&id=4a63c96e"
import script from "./ProjectViewProjectPlanCard.vue?vue&type=script&lang=js"
export * from "./ProjectViewProjectPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports